import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert } from "../../../utils";
import RoutesMap from "../../../route_control/RouteControl"

export const inventoryDashboardTodo = createAsyncThunk('inventoryDashboard', async ({ navigate, from_date, to_date }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `dashboard/inventory`,
            params: {
                from_date: from_date || undefined,
                to_date: to_date || undefined,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const inventoryDashboardSlice = createSlice({
    name: 'inventoryDashboard',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(inventoryDashboardTodo.fulfilled, (state, action) => {
            if (action?.payload?.status == 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status == 401) {
                action?.meta?.arg?.navigate(RoutesMap.LOGIN.path)
            } else if (action?.payload?.status == 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }
        });
        builder.addCase(inventoryDashboardTodo.rejected, (state, action) => {
        })
    }
})

export default inventoryDashboardSlice.reducer;
